import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import { useEffect, useState } from 'react';
import { colorList } from '../constants';
import EmptyHallOfFameList from './EmptyHallOfFameList';
import UserAwardedCard from './UserAwardedCard';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopWrapper = styled.div`
  height: ${Spacings.SPACING_12B};
  position: sticky;
  top: 0px;
  background-color: var(--color-base-1);
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-divider);
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_3B};
  }
`;

const StyText = styled.div`
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.P2};
  color: var(--color-text-secondary);
`;

const CardWrapper = styled.div``;

const CardContainer = styled.div<{ $bottomSticky: boolean }>`
  padding-top: ${Spacings.SPACING_1B};
  padding-bottom: ${Spacings.SPACING_1B};
  position: ${({ $bottomSticky }) => ($bottomSticky ? 'sticky' : 'relative')};
  bottom: ${({ $bottomSticky }) => ($bottomSticky ? '0px' : 'unset')};
  background-color: var(--color-base-1);
  z-index: ${({ $bottomSticky }) => ($bottomSticky ? '1' : 'unset')};
`;

const HallOfFameDialogContent = ({ hallOfFameData }) => {
  const [showUserCard, setShowUserCard] = useState(true);
  const currentUserData = hallOfFameData.find(
    (winner) => winner?.currentUserData === true
  );

  const showEmpty = hallOfFameData.length < 2;

  useEffect(() => {
    const userCard = document.getElementById('user-data');
    const observer = new IntersectionObserver(
      (entries) => {
        setShowUserCard(!entries[0].isIntersecting);
      },
      {
        threshold: 1
      }
    );
    if (userCard) observer.observe(userCard);
  }, []);

  return (
    <Container>
      {!showEmpty && (
        <TopWrapper>
          <StyText>Learners</StyText>
          <StyText>Prizes won</StyText>
        </TopWrapper>
      )}
      <CardWrapper>
        {showEmpty ? (
          <EmptyHallOfFameList />
        ) : (
          hallOfFameData.map((item, index) => {
            return (
              <UserAwardedCard
                key={item}
                cardData={item}
                color={colorList[index]}
                id={item.currentUserData ? 'user-data' : 'list-data'}
                bgColor={index % 2 !== 0 ? 'var(--color-base-0)' : ''}
              />
            );
          })
        )}
        {currentUserData && showUserCard && (
          <CardContainer $bottomSticky>
            <UserAwardedCard cardData={currentUserData} />
          </CardContainer>
        )}
      </CardWrapper>
    </Container>
  );
};

export default HallOfFameDialogContent;
